export const magentoUrlKey = "/graphql";
export const msURlKey = "/api/magento-catalog/v1/graphql";
